import { render, staticRenderFns } from "./PreviewImprimir.vue?vue&type=template&id=1b142b29&"
import script from "./PreviewImprimir.vue?vue&type=script&lang=js&"
export * from "./PreviewImprimir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports